module.exports = __webpack_public_path__ + "static/przelew-internetowy-1f2ac5959db11ff17bce24d43355a3ac.jpg";